import { getGames, getGamesAxios } from '@/api/games.js';
import constants from '@/constants';
import { sortByName } from '@/scripts/tools';

export default {
    state: {
        games: [],
        defaultGame: constants.DEFAULT_GAME,
    },
    getters: {
        GAMES: (state) => {
            return state.games;
        },
        GAMES_BY_ID: (state) => (id) => {
            const gameIndex = state.games.map((game) => game.id).indexOf(id);
            if (gameIndex >= 0) return state.games[gameIndex];
            else return null;
        },
        GAME_BY_PROVIDER_ID: (state) => (id) => {
            if (Number.isNaN(id) || id == null) return state.games;

            const filterGame = [];
            state.games.forEach((game) => {
                if (game.provider_id === id) filterGame.push(game);
            });
            return filterGame;
        },
        GAME_BY_PROVIDERS: (state) => (providerIDList) => {
            if (providerIDList.length === 0) {
                return state.games;
            } else {
                const gameList = [];
                state.games.forEach((game) => {
                    if (providerIDList.includes(game.provider_id) === true) {
                        gameList.push(game);
                    }
                });
                return gameList;
            }
        },
        DEFAULT_GAME: (state) => {
            return state.defaultGame;
        },
        GAME_COUNT: (state) => {
            return state.games.length;
        },
    },
    mutations: {
        GAMES: (state, payload) => {
            const games = payload.length == null ? payload.game_name : payload;
            games.sort((a, b) => sortByName(a, b));
            state.games = games;
        },
        GAME_PUSH: (state, payload) => {
            state.games.push(structuredClone(payload));
        },
        GAME_UPDATE: (state, { id, payload }) => {
            const gameIndex = state.games.map((game) => game.id).indexOf(id);
            if (gameIndex >= 0) {
                state.games[gameIndex] = structuredClone(payload);
            }
        },
        GAME_SPLIT: (state, id) => {
            const gameIndex = state.games.map((game) => game.id).indexOf(id);
            if (gameIndex >= 0) state.games.splice(gameIndex, 1);
        },
    },
    actions: {
        CHECK_GAMES: async function (context) {
            if (context.getters.GAMES.length === 0) {
                context.commit('GAMES', await getGames());
            }
        },
        CHECK_GAMES_AXIOS: async function (context) {
            if (context.getters.GAMES.length === 0) {
                const axiosPromise = await getGamesAxios().catch((error) => {
                    return null;
                });
                return axiosPromise;
            }
            return null;
        },
    },
};
